import { getHTML } from "../../../utilities/getHTML";
import { memberName } from "./memberName";
import { setMemberProps } from "./setMemberProps";
// - [ ] store stripped down deacons, elders evangelists
// - [ ] get article id
// - [ ] get sermon id
// - [ ] correct family id
export function scrapeDirectoryHTML(options) {
    console.time("scrape-html-directory");
    const { needMemberId } = options;
    const localStorageKey = "cp-families";
    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    const storedFamilies = JSON.parse(window.localStorage.getItem(localStorageKey));
    if (storedFamilies &&
        // refresh every day
        storedFamilies.lastModified + oneDay > now.valueOf() &&
        (!needMemberId || // if member id is not needed then return as is
            (needMemberId && "member-id" in storedFamilies.members[0])) // if it is needed, check for it before using stored data
    ) {
        console.timeEnd("scrape-html-directory");
        return Promise.resolve(storedFamilies);
    }
    return getHTML("https://www.cedarparkchurchofchrist.org/members/directory/index/all").then((html) => {
        var _a, _b, _c;
        const membersHTML = html.querySelectorAll(".member-item");
        const families = {};
        const members = [];
        const deacons = [];
        const elders = [];
        if (membersHTML.length) {
            for (let i = 0, l = membersHTML.length; i < l; i++) {
                const memberHTML = membersHTML[i];
                const familyName = (_a = memberHTML.querySelector(".member-name")) === null || _a === void 0 ? void 0 : _a.innerText;
                const lastName = familyName.split(",")[0];
                const fullAddress = (_b = memberHTML.querySelector(".full-address")) === null || _b === void 0 ? void 0 : _b.innerText;
                const splitAddress = fullAddress === null || fullAddress === void 0 ? void 0 : fullAddress.split(", ");
                const stateZip = (_c = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress[2]) === null || _c === void 0 ? void 0 : _c.split(" ");
                const familyMembersHTML = memberHTML.querySelector(".sub-item");
                const familyId = memberHTML
                    .querySelector(".member-download a")
                    .getAttribute("href")
                    .match(/\d+/)[0];
                let family = families[familyName];
                if (!family) {
                    family = {
                        "family-id": familyId,
                        "family-name": familyName,
                        members: [],
                        groups: [],
                    };
                    families[familyName] = family;
                }
                family["thumb-photo-url"] = memberHTML
                    .querySelector(".member-img img")
                    .getAttribute("src")
                    .split("?")[0];
                family["family-photo-url"] = family["thumb-photo-url"].replace("/thumbs", "");
                family["last-name"] = lastName;
                family["full-address"] = fullAddress;
                family["zip-code"] = stateZip === null || stateZip === void 0 ? void 0 : stateZip[1];
                family["membership-status"] = "C";
                family.address = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress[0];
                family.city = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress[1];
                family.state = stateZip === null || stateZip === void 0 ? void 0 : stateZip[0];
                let currentSubItem = familyMembersHTML.firstChild;
                let member = {};
                while (currentSubItem) {
                    const itemText = currentSubItem === null || currentSubItem === void 0 ? void 0 : currentSubItem.innerText;
                    if (itemText) {
                        setMemberProps(currentSubItem, member, families, familyName);
                        memberName(currentSubItem, itemText, member, lastName);
                    }
                    currentSubItem =
                        currentSubItem.nextElementSibling;
                    if ((currentSubItem === null || currentSubItem === void 0 ? void 0 : currentSubItem.classList.contains("sub-member")) &&
                        Object.keys(member).length) {
                        member["family-id"] = familyId;
                        member["family-photo-url"] = family["family-photo-url"];
                        if (member.groups) {
                            // deacons
                            if (member.groups.indexOf("Deacons") > -1 &&
                                member.groups.indexOf("Elders") === -1) {
                                deacons.push(member);
                            }
                            // elders
                            if (member.groups.indexOf("Elders") > -1) {
                                elders.push(member);
                            }
                        }
                        members.push(member);
                        family.members.push(member);
                        member = {}; // reset member
                    }
                }
            }
        }
        else {
            console.warn("Login required to display directory");
        }
        const cpFamilies = {
            lastModified: now.valueOf(),
            families,
            members,
            elders,
            deacons,
        };
        window.localStorage.setItem(localStorageKey, JSON.stringify(cpFamilies));
        // dataSet("leadership", {
        //     elders,
        //     deacons,
        // });
        console.timeEnd("scrape-html-directory");
        return cpFamilies;
    });
}
